export enum Roles {
    BASIC_USER = 'BASIC_USER',
    ADMIN = 'ADMIN',
    /**
     * Archived users are blocked from accessing the application. The role is
     * applied via the "Archive User" admin action and replaces all other roles.
     * It is intentionally NOT exposed in role selection dropdowns.
     */
    ARCHIVED = 'ARCHIVED'
}
